import { ButtonProps, Button } from "react-bootstrap";
import getClasses from "utils/getClasses";
import styles from "./styles.module.scss";
import { usePhonePortraitContext } from "contexts/phone-portrait-context";

const ExtraLargeButton = ({ className, ...props }: ButtonProps) => {
  const { isPhonePortrait } = usePhonePortraitContext();
  return (
    <Button
      className={getClasses(
        !isPhonePortrait
          ? styles["extra-large-button"]
          : styles["extra-large-button--phone"],
        className,
      )}
      {...props}
    />
  );
};
export default ExtraLargeButton;
